var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef, useState } from 'react';
import { Box } from '../Layout';
import { useDialogStyles } from './DialogStylingContext';
import { styled } from '@mui/material/styles';
var styledBoxForwardableProps = ['dividers', 'nonScrollable'];
var StyledBox = styled(Box, {
    shouldForwardProp: function (key) {
        return !styledBoxForwardableProps.includes(key);
    },
})(function (_a) {
    var theme = _a.theme, _b = _a.nonScrollable, nonScrollable = _b === void 0 ? false : _b, dividers = _a.dividers;
    var _c = useDialogStyles(), _d = _c.padding, paddingLeft = _d.paddingLeft, paddingRight = _d.paddingRight, scroll = _c.scroll;
    return __assign(__assign({ flex: '1 1 auto', paddingLeft: paddingLeft, paddingRight: paddingRight, paddingBottom: 8 }, (nonScrollable || scroll === 'body' ? {} : { overflowY: 'auto' })), (dividers
        ? {
            borderBottom: "1px solid ".concat(theme.palette.divider),
            borderTop: "1px solid ".concat(theme.palette.divider),
            paddingTop: 16,
            paddingBottom: 16,
            marginTop: 4,
        }
        : {}));
});
var DialogContent = function (_a) {
    var _b = _a.dividers, dividers = _b === void 0 ? 'auto' : _b, props = __rest(_a, ["dividers"]);
    var ref = useRef(null);
    var _c = useState(false), hasScrollbar = _c[0], setHasScrollbar = _c[1];
    useEffect(function () {
        var checkScrollbar = function () {
            var element = ref.current;
            if (element) {
                var isScrollbarVisible = element.scrollHeight > element.clientHeight;
                setHasScrollbar(isScrollbarVisible);
            }
        };
        checkScrollbar();
        window.addEventListener('resize', checkScrollbar);
        return function () { return window.removeEventListener('resize', checkScrollbar); };
    }, []);
    return (React.createElement(StyledBox, __assign({ dividers: dividers === 'auto' ? hasScrollbar : dividers }, props, { ref: ref })));
};
export default DialogContent;
//# sourceMappingURL=DialogContent.js.map